import { ImageCTA } from "components";
import { useStoryblokLink } from "hooks";
import type { ReactStoryblokComponent } from "types/storyblok";
import { ImageCTAVariantsMap } from "./ImageCTA.config";
import type { CTASAdapterProps } from "./ImageCTA.d";

const ImageCTASAdapter = ({
  blok: { heading, buttonText, buttonLink, imageUrl, gtmSection, gtmElement, variant = "option-1" },
}: ReactStoryblokComponent<CTASAdapterProps>) => {
  const resolvedButtonUrl = useStoryblokLink(buttonLink);

  return (
    <ImageCTA
      text={heading}
      buttonText={buttonText}
      buttonHref={resolvedButtonUrl}
      imageUrl={imageUrl || undefined}
      gtmSection={gtmSection}
      gtmElement={gtmElement}
      variant={ImageCTAVariantsMap[variant] || "basic"}
    />
  );
};

export default ImageCTASAdapter;
